import { IonIcon, IonLabel } from '@ionic/react'
import { chevronForward } from 'ionicons/icons'
import React, { useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { ModalContext } from '../../../contexts/ModalContext'
import { SettingsCardData } from '../../types/settingsCardData'

const ProfileInformationCard: React.FC<SettingsCardData> = ({
	label,
	icon,
	modal,
	page,
	isRendered = true,
}) => {
	const { insertModal } = useContext(ModalContext)
	const history = useHistory()

	if (!isRendered) return null

	return (
		<div
			onClick={() => {
				if (page) {
					history.push(`/${page}`)
				} else if (modal) {
					insertModal(modal)
				}
			}}
			className='flex flex-row items-center justify-between rounded-xl py-6 px-8 shadow-md group hover bg-white dark:bg-brand-secondary-200-dark'
		>
			<div className='flex flex-row items-center gap-6'>
				<IonIcon
					className='text-[1.4rem] text-brand-primary-100-light dark:text-brand-primary-100-dark'
					icon={icon}
				/>
				<IonLabel className='text-text-dark dark:text-white'>{label}</IonLabel>
			</div>
			<IonIcon
				className='text-[2.15rem] text-[#a3a3a3] dark:text-[#c8c8c8] transition-transform group-hover:scale-[1.2] group-hover:transition-transform'
				icon={chevronForward}
			/>
		</div>
	)
}

export default ProfileInformationCard
